/* Promo NFL · "Explicar promo" — narrated, auto-scrolling walkthrough of the landing.
   Trigger: [data-nfl-explica] buttons (hero + floating). Never starts without a click.
   Data: #nfl-explica-data = { src: audio URLs, timeline: { music, levels, steps } }.
   The timeline is generated from the voice alignment (_nfl-audio/vo-v2/build-timeline.mjs):
   step.at = voice start on the music clock, cue times are seconds relative to it.
   Audio: everything (music, 8 voice clips, SFX, ducking) is scheduled up front on ONE
   Web Audio context created inside the click (iOS unlock), so Pause (ctx.suspend)
   freezes sound and visuals together. Visual cues fire from a rAF loop that reads the
   same audio clock: scroll to the section, big kinetic words over the page, marker
   highlights on the words being said, pops, rails, the dates marker, playbook doodles.
   Stops on Esc, the stop button, or manual wheel/touch scrolling after a grace
   period; everything on the page is restored on stop. */
(function () {
  'use strict';
  var page = document.querySelector('.nfl-page');
  var dataEl = document.getElementById('nfl-explica-data');
  if (!page || !dataEl) return;
  var AC = window.AudioContext || window.webkitAudioContext;
  var triggers = document.querySelectorAll('[data-nfl-explica]');
  if (!AC) { Array.prototype.forEach.call(triggers, function (b) { b.hidden = true; }); return; }

  var DATA;
  try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var SRC = DATA.src || {}, TL = DATA.timeline || {};
  var LV = TL.levels || { music: 0.52, duck: 0.25, finale: 0.62, crowd: 0.16, voice: 1, sfx: 0.6 };
  var MASTER = 1.4; // volumen general
  var MUSIC = TL.music || { end: 62 };
  var STEPS = (TL.steps || []).filter(function (s) { return document.querySelector(s.target); });
  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function reduced() { return !!(mq && mq.matches); }

  /* ---------- state ---------- */
  var S = null;
  var ctx = null, buffers = {}, loading = {};
  var bar = null, kin = null, ctaTimer = 0;

  function q(sel, root) { try { return (root || document).querySelector(sel); } catch (e) { return null; } }
  function qa(sel, root) { try { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); } catch (e) { return []; } }
  function clamp01(x) { return x < 0 ? 0 : x > 1 ? 1 : x; }

  /* ---------- audio ---------- */
  function decode(ab) {
    return new Promise(function (res, rej) {
      var p = ctx.decodeAudioData(ab, res, rej);
      if (p && p.then) p.then(res, rej);
    });
  }
  function load(key) {
    if (buffers[key]) return Promise.resolve(buffers[key]);
    if (!SRC[key]) return Promise.reject(new Error('no src ' + key));
    if (!loading[key]) {
      loading[key] = fetch(SRC[key], { credentials: 'omit' })
        .then(function (r) { if (!r.ok) throw new Error(key + ' ' + r.status); return r.arrayBuffer(); })
        .then(decode)
        .then(function (b) { buffers[key] = b; return b; })
        .catch(function (e) { delete loading[key]; throw e; });
    }
    return loading[key];
  }
  // schedule a buffer at audio time `when` (absolute ctx time)
  function play(key, bus, when, opts) {
    opts = opts || {};
    var b = buffers[key];
    if (!b || !S) return null;
    var src = ctx.createBufferSource();
    src.buffer = b;
    if (opts.loop) src.loop = true;
    var g = ctx.createGain();
    g.gain.value = opts.gain == null ? 1 : opts.gain;
    src.connect(g); g.connect(bus);
    src.start(Math.max(ctx.currentTime, when), opts.offset || 0);
    var h = { src: src, gain: g };
    S.sources.push(h);
    return h;
  }
  function ramp(param, v, t) {
    var now = ctx.currentTime;
    param.cancelScheduledValues(now);
    param.setValueAtTime(param.value, now);
    param.linearRampToValueAtTime(v, now + (t || 0.3));
  }
  // light ducking: the bed sits at LV.duck while David talks and only comes back up
  // in gaps long enough to be heard (intro, the move to the end zone, the finale)
  function scheduleDucking(T0) {
    var g = S.musicBus.gain, lvl = LV.music;
    g.cancelScheduledValues(0);
    g.setValueAtTime(lvl, T0);
    STEPS.forEach(function (s, i) {
      var a = T0 + s.at, e = T0 + s.at + s.end, nxt = STEPS[i + 1];
      if (lvl !== LV.duck) { g.setValueAtTime(lvl, a - 0.35); g.linearRampToValueAtTime(LV.duck, a - 0.05); lvl = LV.duck; }
      var gap = nxt ? nxt.at - (s.at + s.end) : Infinity;
      if (gap > 0.9) {
        var up = nxt ? LV.music : LV.finale;
        g.setValueAtTime(LV.duck, e + 0.05); g.linearRampToValueAtTime(up, e + 0.45); lvl = up;
      }
    });
  }

  /* ---------- scrolling ---------- */
  // Fixed header height to clear. This theme's header (fb-chrome.js) slides away on
  // scroll-down and comes back on scroll-up, so it only counts when moving up.
  function headerOffset(goingDown) {
    var max = 0;
    var autoHides = !!document.querySelector('.fb-head-spacer');
    qa('.site-header, #shopify-section-header, header, sticky-header, .header-wrapper').forEach(function (h) {
      var cs = getComputedStyle(h);
      if (cs.position !== 'fixed' && cs.position !== 'sticky') return;
      if (goingDown && autoHides && h.classList.contains('site-header')) return;
      var r = h.getBoundingClientRect();
      if (r.height && r.height < window.innerHeight * 0.4) max = Math.max(max, r.height + Math.max(0, cs.position === 'fixed' ? parseFloat(cs.top) || 0 : 0));
    });
    return max;
  }
  function scrollToY(y, done) {
    y = Math.max(0, Math.min(y, document.documentElement.scrollHeight - window.innerHeight));
    var from = window.pageYOffset, dist = y - from;
    if (reduced() || Math.abs(dist) < 4) { window.scrollTo(0, y); return done && done(); }
    var dur = Math.min(700, Math.max(500, Math.abs(dist) * 0.3)), t0 = null;
    var token = S && (S.scrollToken = {});
    function step(ts) {
      if (!S || S.scrollToken !== token) return;
      if (t0 === null) t0 = ts;
      var k = Math.min(1, (ts - t0) / dur);
      var e = k < 0.5 ? 4 * k * k * k : 1 - Math.pow(-2 * k + 2, 3) / 2;
      window.scrollTo(0, from + dist * e);
      if (k < 1) requestAnimationFrame(step); else if (done) done();
    }
    requestAnimationFrame(step);
  }
  // room the kinetic words take at the bottom, so centred content stays clear of them
  function kinReserve() { return window.innerWidth < 750 ? 90 : 130; }
  function scrollToEl(el, align, done) {
    var r = el.getBoundingClientRect();
    var off = headerOffset(r.top > 4 && window.pageYOffset + r.top > 200);
    var y = window.pageYOffset + r.top - off - 8;
    if (align === 'center') {
      var avail = window.innerHeight - off - (bar ? bar.offsetHeight + 24 : 0) - kinReserve();
      y = window.pageYOffset + r.top - off - Math.max(8, (avail - r.height) / 2);
    }
    scrollToY(y, done);
  }

  /* ---------- page cues ---------- */
  function restartClass(el, cls) {
    if (!el || !S) return;
    el.classList.remove(cls);
    void el.offsetWidth;
    el.classList.add(cls);
    S.touched.push(function () { el.classList.remove(cls); });
  }
  // pops and glows go through the Web Animations API: they layer on top of the page's own
  // CSS entrance animations (nfl-rise, nflBugIn) instead of replacing them
  var anims = [];
  function wa(el, frames, opts) {
    if (!el || !S || !el.animate || reduced()) return;
    var a = el.animate(frames, opts);
    anims.push(a);
    a.onfinish = function () { var k = anims.indexOf(a); if (k > -1) anims.splice(k, 1); };
  }
  function pop(el) {
    wa(el, [{ transform: 'scale(.94)' }, { transform: 'scale(1.045)', offset: .55 }, { transform: 'scale(1)' }],
      { duration: 650, easing: 'cubic-bezier(.3, 1.5, .5, 1)', composite: 'add' });
    if (el && el.classList.contains('nfl-tier')) restartClass(el, 'nfl-xp-lit');
  }
  function glow(el) {
    wa(el, [{ filter: 'drop-shadow(0 0 0 rgba(232, 196, 106, 0))' }, { filter: 'drop-shadow(0 0 22px rgba(232, 196, 106, .85))', offset: .35 }, { filter: 'drop-shadow(0 0 0 rgba(232, 196, 106, 0))' }],
      { duration: 1800, easing: 'ease' });
  }
  function railScroll(rail, secs) {
    if (!rail || reduced()) return;
    var max = rail.scrollWidth - rail.clientWidth;
    if (max < 20) return;
    var start = rail.scrollLeft, to = Math.min(max, start + rail.clientWidth * 0.9);
    S.touched.push(function () { rail.scrollLeft = start; });
    var t0 = null, dur = (secs || 2.6) * 1000, session = S;
    function f(ts) {
      if (S !== session) return;
      if (t0 === null) t0 = ts;
      var k = Math.min(1, (ts - t0) / dur), e = 0.5 - Math.cos(Math.PI * k) / 2;
      rail.scrollLeft = start + (to - start) * e;
      if (k < 1) requestAnimationFrame(f);
    }
    requestAnimationFrame(f);
  }
  function drivePoint(i) {
    var drive = q('[data-nfl-drive]'); if (!drive) return;
    var track = q('.nfl-drive__track', drive), lis = qa('[data-at]', drive);
    if (!track || !lis.length) return;
    if (!S.driveSaved) {
      var savedProg = drive.style.getPropertyValue('--progress');
      var savedPast = lis.map(function (li) { return li.classList.contains('is-past'); });
      S.driveSaved = true;
      S.touched.push(function () {
        drive.style.setProperty('--progress', savedProg);
        lis.forEach(function (li, k) { li.classList.toggle('is-past', savedPast[k]); li.classList.remove('nfl-xp-hit'); });
      });
    }
    if (i < 0) {
      lis.forEach(function (li) { li.classList.remove('is-past', 'nfl-xp-hit'); });
      drive.style.setProperty('--progress', '0');
      return;
    }
    var horizontal = track.offsetWidth > track.offsetHeight, tr = track.getBoundingClientRect();
    var len = horizontal ? tr.width : tr.height, r = lis[i].getBoundingClientRect();
    var pos = horizontal ? (r.left - tr.left + 9) : (r.top - tr.top + 15);
    drive.style.setProperty('--progress', clamp01(pos / len).toFixed(4));
    lis.forEach(function (li, k) { li.classList.toggle('is-past', k <= i); li.classList.toggle('nfl-xp-hit', k === i); });
  }
  function accOpen(i) {
    var items = qa('.nfl-acc__item'), d = items[i];
    if (!d) return;
    if (!S.accSaved) {
      var saved = items.map(function (x) { return x.open; });
      S.accSaved = true;
      S.touched.push(function () { items.forEach(function (x, k) { x.open = saved[k]; x.classList.remove('nfl-xp-hit'); }); });
    }
    d.open = true;
    items.forEach(function (x) { x.classList.toggle('nfl-xp-hit', x === d); });
    scrollToEl(d, 'center');
  }
  // wrap a phrase that is already on the page in a temporary marker swipe
  function highlight(sel, phrase, root) {
    var host = q(sel, root) || q(sel);
    if (!host || !phrase) return;
    var walker = document.createTreeWalker(host, NodeFilter.SHOW_TEXT, null, false), n;
    while ((n = walker.nextNode())) {
      var idx = n.nodeValue.indexOf(phrase);
      if (idx < 0 || (n.parentNode && n.parentNode.classList && n.parentNode.classList.contains('nfl-xp-hl'))) continue;
      var target = idx > 0 ? n.splitText(idx) : n;
      if (target.nodeValue.length > phrase.length) target.splitText(phrase.length);
      var mark = document.createElement('mark');
      mark.className = 'nfl-xp-hl';
      target.parentNode.insertBefore(mark, target);
      mark.appendChild(target);
      S.touched.push(function () {
        var p = mark.parentNode; if (!p) return;
        while (mark.firstChild) p.insertBefore(mark.firstChild, mark);
        p.removeChild(mark); p.normalize();
      });
      return;
    }
  }
  function flash(strong) {
    if (reduced()) return;
    var f = document.createElement('div');
    f.className = 'nfl-xp-flash' + (strong ? ' is-strong' : '');
    f.setAttribute('aria-hidden', 'true');
    document.body.appendChild(f);
    setTimeout(function () { f.remove(); }, 700);
  }
  function ctaOn() {
    var cta = q('.nfl-endzone .nfl-btn');
    if (!cta) return;
    clearTimeout(ctaTimer);
    cta.classList.add('nfl-xp-cta');
  }
  function ctaOff() { clearTimeout(ctaTimer); qa('.nfl-xp-cta').forEach(function (b) { b.classList.remove('nfl-xp-cta'); }); }

  /* ---------- kinetic typography ---------- */
  function buildKin() {
    if (kin) return kin;
    kin = document.createElement('div');
    kin.className = 'nfl-xp-kin';
    kin.setAttribute('aria-hidden', 'true');
    document.body.appendChild(kin);
    return kin;
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function kinOut(c, fast) {
    if (c.classList.contains('is-out')) return;
    c.classList.add('is-out');
    setTimeout(function () { c.remove(); }, fast ? 170 : 240);
  }
  function kinClear(fast) { if (kin) qa('.nfl-xp-card', kin).forEach(function (c) { kinOut(c, fast); }); }
  function kinShow(o) {
    if (!S) return;
    buildKin();
    kinClear();
    var style = o.style || 'slam';
    var text = String(o.text || '');
    var card = document.createElement('div');
    card.className = 'nfl-xp-card is-' + style + (text.length > 15 ? ' is-long' : '') + (text.length > 21 ? ' is-xlong' : '');
    var body;
    if (style === 'flip') {
      body = text.split('').map(function (ch, i) {
        if (ch === ' ') return '<span class="nfl-xp-sp"></span>';
        return /[0-9]/.test(ch) ? '<span class="nfl-xp-tile" style="--i:' + i + '" data-d="' + ch + '">' + ch + '</span>'
                                : '<span class="nfl-xp-ch" style="--i:' + i + '">' + esc(ch) + '</span>';
      }).join('');
    } else body = esc(text);
    card.innerHTML =
      (o.k ? '<span class="nfl-xp-card__k">' + esc(o.k) + '</span>' : '') +
      '<span class="nfl-xp-card__t">' + body + '</span>' +
      (o.sub ? '<span class="nfl-xp-card__s">' + esc(o.sub) + '</span>' : '');
    kin.appendChild(card);
    if (style === 'count') countTo(q('.nfl-xp-card__t', card), o.from || 0, text);
    if (style === 'flip') rollTiles(card);
    if (style === 'stamp' && !reduced()) restartClass(kin, 'is-shake');
    var hold = o.dur != null ? o.dur : (style === 'finale' ? 0 : 1.6);
    if (hold) {
      var session = S;
      later(hold, function () { if (S === session && card.parentNode) kinOut(card); });
    }
    S.card = card;
  }
  // "$3,500": count from `from` to the number in the text, keeping its format
  function countTo(el, from, text) {
    var to = parseInt(text.replace(/[^0-9]/g, ''), 10);
    if (!el || isNaN(to) || reduced()) return;
    var pre = text.match(/^[^0-9]*/)[0], t0 = null, dur = 420, session = S;
    function fmt(v) { return pre + Math.round(v).toLocaleString('en-US'); }
    el.textContent = fmt(from);
    function f(ts) {
      if (S !== session) return;
      if (t0 === null) t0 = ts;
      var k = Math.min(1, (ts - t0) / dur);
      el.textContent = fmt(from + (to - from) * (1 - Math.pow(1 - k, 3)));
      if (k < 1) requestAnimationFrame(f); else el.textContent = text;
    }
    requestAnimationFrame(f);
  }
  // scoreboard: every digit tile rolls through a few numbers before it settles
  function rollTiles(card) {
    if (reduced()) return;
    qa('.nfl-xp-tile', card).forEach(function (t, i) {
      var fin = t.getAttribute('data-d'), n = 0, rolls = 3 + (i % 3);
      var iv = setInterval(function () {
        if (++n > rolls || !S) { clearInterval(iv); t.textContent = fin; return; }
        t.textContent = String((+fin + n * 3) % 10);
      }, 45);
    });
  }
  function punch() { if (S && S.card) restartClass(S.card, 'is-punch'); }

  /* ---------- cue runner ---------- */
  function runCue(c, step) {
    var kind = c[1], root = step.el;
    if (kind === 'kin') kinShow(c[2]);
    else if (kind === 'hl') highlight(c[2], c[3], root);
    else if (kind === 'pop') pop(q(c[2], root) || q(c[2]));
    else if (kind === 'glow') glow(q(c[2], root) || q(c[2]));
    else if (kind === 'popList') qa(c[2], root).forEach(function (el, k) { later(k * (c[3] || 0.15), function () { pop(el); }); });
    else if (kind === 'tier') pop(qa('.nfl-tier', root)[c[2]]);
    else if (kind === 'rail') railScroll(q(c[2]), c[3]);
    else if (kind === 'drive') drivePoint(c[2]);
    else if (kind === 'acc') accOpen(c[2]);
    else if (kind === 'scroll') { var el = q(c[2], root); if (el) scrollToEl(el, 'center'); }
    else if (kind === 'flash') { flash(true); punch(); }
    else if (kind === 'cta') ctaOn();
    else if (kind === 'final') { flash(false); punch(); restartClass(q('.nfl-endzone .nfl-xp-cta'), 'nfl-xp-cta-hit'); }
    // 'sfx' is scheduled on the audio graph up front
  }
  // one-shot timers on the audio clock (seconds), so Pause freezes them too
  function later(sec, fn) { S.timers.push({ t: ctx.currentTime + sec, fn: fn }); }

  function tick() {
    if (!S) return;
    var now = ctx.currentTime, t = now - S.T0;
    if (S.timers.length) {
      var due = S.timers.filter(function (x) { return x.t <= now; });
      if (due.length) { S.timers = S.timers.filter(function (x) { return x.t > now; }); due.forEach(function (x) { if (S) x.fn(); }); }
    }
    if (!S) return;
    var idx = S.i;
    while (idx + 1 < STEPS.length && t >= STEPS[idx + 1].at + STEPS[idx + 1].enter) idx++;
    if (idx !== S.i) enterStep(idx);
    var step = STEPS[S.i];
    if (step && step.el) {
      var rel = t - step.at;
      for (var k = 0; k < step.cues.length && S; k++) {
        if (!step.fired[k] && rel >= step.cues[k][0]) { step.fired[k] = true; runCue(step.cues[k], step); }
      }
      if (!S) return;
      var from = step.at + step.enter, nxt = STEPS[S.i + 1];
      var to = nxt ? nxt.at + nxt.enter : MUSIC.end;
      if (S.seg) S.seg.style.transform = 'scaleX(' + clamp01((t - from) / (to - from)).toFixed(3) + ')';
      if (step.play && window.NflPlaybook && window.NflPlaybook.drive) window.NflPlaybook.drive(step.el, clamp01(rel / (step.end + 0.3)));
    }
    if (t >= MUSIC.end && !S.finishing) finish();
    if (S) S.raf = requestAnimationFrame(tick);
  }

  function enterStep(i) {
    S.i = i;
    var step = STEPS[i];
    step.el = q(step.target);
    step.fired = step.cues.map(function () { return false; });
    page.querySelectorAll('.nfl-xp-on').forEach(function (n) { n.classList.remove('nfl-xp-on'); });
    if (window.NflPlaybook && window.NflPlaybook.release) window.NflPlaybook.release();
    kinClear(true);
    setStepLabel(i);
    step.el.classList.add('nfl-xp-on');
    frame(step.el);
    scrollToEl(step.el, 'top');
  }

  function frame(sec) {
    var f = document.createElement('div');
    f.className = 'nfl-xp-frame';
    f.setAttribute('aria-hidden', 'true');
    f.innerHTML = '<i></i><i></i><i></i><i></i><span class="nfl-xp-frame__sweep"></span>';
    sec.appendChild(f);
    var prev = S.frame; S.frame = f;
    if (prev) { prev.classList.add('is-out'); setTimeout(function () { prev.remove(); }, 450); }
  }

  /* ---------- UI ---------- */
  var ICON = {
    play: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5.5v13l11-6.5z" fill="currentColor"/></svg>',
    pause: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 5h3.5v14H7zM13.5 5H17v14h-3.5z" fill="currentColor"/></svg>',
    stop: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="6" y="6" width="12" height="12" rx="1.5" fill="currentColor"/></svg>',
    sound: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 9.5h3.5L12 5.5v13l-4.5-4H4z" fill="currentColor" stroke="none"/><path d="M15.5 9a4 4 0 0 1 0 6M18 6.5a7.5 7.5 0 0 1 0 11"/></svg>',
    muted: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 9.5h3.5L12 5.5v13l-4.5-4H4z" fill="currentColor" stroke="none"/><path d="M16 9.5l5 5M21 9.5l-5 5"/></svg>'
  };
  function buildBar() {
    if (bar) return bar;
    bar = document.createElement('div');
    bar.className = 'nfl-xp-bar';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Explicación narrada de la promoción');
    var segs = STEPS.map(function () { return '<span class="nfl-xp-seg"><i></i></span>'; }).join('');
    bar.innerHTML =
      '<div class="nfl-xp-bar__top">' +
        '<span class="nfl-xp-bar__live"><b></b>Explicación</span>' +
        '<span class="nfl-xp-bar__step" data-xp-step aria-live="polite"></span>' +
        '<span class="nfl-xp-bar__btns">' +
          '<button type="button" class="nfl-xp-btn" data-xp-pause aria-label="Pausar">' + ICON.pause + '</button>' +
          '<button type="button" class="nfl-xp-btn" data-xp-mute aria-label="Silenciar" aria-pressed="false">' + ICON.sound + '</button>' +
          '<button type="button" class="nfl-xp-btn nfl-xp-btn--stop" data-xp-stop aria-label="Detener explicación">' + ICON.stop + '</button>' +
        '</span>' +
      '</div>' +
      '<div class="nfl-xp-bar__segs" aria-hidden="true">' + segs + '</div>';
    document.body.appendChild(bar);
    q('[data-xp-stop]', bar).addEventListener('click', function () { stop(); });
    q('[data-xp-pause]', bar).addEventListener('click', togglePause);
    q('[data-xp-mute]', bar).addEventListener('click', toggleMute);
    return bar;
  }
  function setStatus(t) { q('[data-xp-step]', bar).textContent = t; }
  function setStepLabel(i) {
    setStatus((i + 1) + ' / ' + STEPS.length + ' · ' + STEPS[i].label);
    qa('.nfl-xp-seg', bar).forEach(function (s, k) {
      s.classList.toggle('is-done', k < i); s.classList.toggle('is-now', k === i);
      if (k !== i) q('i', s).style.transform = k < i ? 'scaleX(1)' : 'scaleX(0)';
    });
    S.seg = q('.nfl-xp-seg.is-now i', bar);
  }
  function togglePause() {
    if (!S || !ctx || S.T0 == null) return;
    S.autoPaused = false;
    var btn = q('[data-xp-pause]', bar);
    if (S.paused) {
      S.paused = false; ctx.resume();
      btn.innerHTML = ICON.pause; btn.setAttribute('aria-label', 'Pausar');
      bar.classList.remove('is-paused'); document.documentElement.classList.remove('nfl-xp-paused');
    } else {
      S.paused = true; ctx.suspend();
      btn.innerHTML = ICON.play; btn.setAttribute('aria-label', 'Reanudar');
      bar.classList.add('is-paused'); document.documentElement.classList.add('nfl-xp-paused');
    }
  }
  function toggleMute() {
    if (!S) return;
    S.muted = !S.muted;
    ramp(S.master.gain, S.muted ? 0 : MASTER, 0.15);
    var btn = q('[data-xp-mute]', bar);
    btn.innerHTML = S.muted ? ICON.muted : ICON.sound;
    btn.setAttribute('aria-pressed', String(S.muted));
    btn.setAttribute('aria-label', S.muted ? 'Activar sonido' : 'Silenciar');
  }

  /* ---------- flow ---------- */
  function start(e) {
    if (e) e.preventDefault();
    if (S || !STEPS.length) return;
    // Everything audio-related happens synchronously inside the click (iOS).
    try { if (navigator.audioSession) navigator.audioSession.type = 'playback'; } catch (err) {}
    if (!ctx) ctx = new AC();
    if (ctx.state === 'suspended') ctx.resume();
    var unlock = ctx.createBufferSource();
    unlock.buffer = ctx.createBuffer(1, 1, 22050);
    unlock.connect(ctx.destination); unlock.start(0);

    S = { i: -1, sources: [], timers: [], touched: [], paused: false, muted: false, t0: Date.now(), raf: 0, T0: null };
    S.master = ctx.createGain(); S.master.gain.value = MASTER;
    // limitador: el volumen subido no debe saturar en los golpes de metales
    S.limiter = ctx.createDynamicsCompressor();
    S.limiter.threshold.value = -3; S.limiter.knee.value = 2; S.limiter.ratio.value = 20;
    S.limiter.attack.value = 0.003; S.limiter.release.value = 0.12;
    S.master.connect(S.limiter); S.limiter.connect(ctx.destination);
    S.musicBus = ctx.createGain(); S.musicBus.gain.value = LV.music; S.musicBus.connect(S.master);
    S.voiceBus = ctx.createGain(); S.voiceBus.gain.value = LV.voice; S.voiceBus.connect(S.master);
    S.sfxBus = ctx.createGain(); S.sfxBus.gain.value = LV.sfx; S.sfxBus.connect(S.master);
    S.crowdBus = ctx.createGain(); S.crowdBus.gain.value = LV.crowd; S.crowdBus.connect(S.master);

    ctaOff();
    buildBar(); buildKin();
    document.documentElement.classList.add('nfl-xp-run');
    S.prevScrollBehavior = document.documentElement.style.scrollBehavior;
    document.documentElement.style.scrollBehavior = 'auto';
    // show every reveal-on-scroll block now, so nothing fades in late mid-explanation
    qa('[data-reveal]', page).forEach(function (n) { n.classList.add('is-in'); });
    bar.classList.add('is-on', 'is-loading');
    setStatus('Cargando audio');
    qa('.nfl-xp-seg', bar).forEach(function (s) { s.classList.remove('is-done', 'is-now'); q('i', s).style.transform = 'scaleX(0)'; });
    Array.prototype.forEach.call(triggers, function (b) { b.setAttribute('aria-expanded', 'true'); });

    window.addEventListener('wheel', onUserScroll, { passive: true });
    window.addEventListener('touchmove', onUserScroll, { passive: true });
    window.addEventListener('keydown', onKey);
    document.addEventListener('visibilitychange', onVis);

    // the show is ~62 s of tightly cued audio: load all of it (about 1.5 MB) first
    var session = S;
    Promise.all(Object.keys(SRC).map(load)).then(function () {
      if (S !== session) return;
      bar.classList.remove('is-loading');
      var T0 = ctx.currentTime + 0.12;
      S.T0 = T0;
      play('music', S.musicBus, T0);
      play('sfx_crowd', S.crowdBus, T0, { loop: true });
      STEPS.forEach(function (s) {
        play(s.vo, S.voiceBus, T0 + s.at);
        s.cues.forEach(function (c) { if (c[1] === 'sfx') play('sfx_' + c[2], S.sfxBus, T0 + s.at + c[0]); });
      });
      scheduleDucking(T0);
      document.documentElement.classList.add('nfl-xp-live');
      S.raf = requestAnimationFrame(tick);
    }, function () {
      if (S !== session) return;
      bar.classList.remove('is-loading');
      setStatus('No se pudo cargar el audio');
      setTimeout(function () { if (S === session) stop(); }, 2600);
    });
  }

  function finish() {
    S.finishing = true;
    ramp(S.master.gain, 0, 0.5);
    later(0.55, function () { stop(true); });
  }

  function stop(completed) {
    if (!S) return;
    var s = S; S = null;
    s.timers = [];
    cancelAnimationFrame(s.raf);
    s.sources.forEach(function (h) { try { h.src.stop(); } catch (e) {} try { h.gain.disconnect(); } catch (e) {} });
    try { s.master.disconnect(); } catch (e) {}
    try { s.limiter.disconnect(); } catch (e) {}
    if (ctx) setTimeout(function () { if (!S && ctx.state === 'running') ctx.suspend(); }, 300);
    anims.splice(0).forEach(function (a) { try { a.cancel(); } catch (e) {} });
    s.touched.forEach(function (fn) { try { fn(); } catch (e) {} });
    qa('.nfl-xp-frame').forEach(function (f) { f.remove(); });
    kinClear(true);
    page.querySelectorAll('.nfl-xp-on').forEach(function (n) { n.classList.remove('nfl-xp-on'); });
    if (window.NflPlaybook && window.NflPlaybook.release) window.NflPlaybook.release();
    document.documentElement.classList.remove('nfl-xp-run', 'nfl-xp-live', 'nfl-xp-paused');
    document.documentElement.style.scrollBehavior = s.prevScrollBehavior || '';
    window.removeEventListener('wheel', onUserScroll);
    window.removeEventListener('touchmove', onUserScroll);
    window.removeEventListener('keydown', onKey);
    document.removeEventListener('visibilitychange', onVis);
    if (bar) {
      bar.classList.remove('is-on', 'is-loading', 'is-paused');
      var pb = q('[data-xp-pause]', bar); pb.innerHTML = ICON.pause; pb.setAttribute('aria-label', 'Pausar');
      var mb = q('[data-xp-mute]', bar); mb.innerHTML = ICON.sound; mb.setAttribute('aria-pressed', 'false'); mb.setAttribute('aria-label', 'Silenciar');
    }
    Array.prototype.forEach.call(triggers, function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (completed) {
      // end on the CTA: keep it lit for a few seconds and give it focus
      var cta = q('.nfl-endzone .nfl-xp-cta') || q('.nfl-endzone .nfl-btn');
      if (cta) { cta.classList.add('nfl-xp-cta'); try { cta.focus({ preventScroll: true }); } catch (e) {} }
      ctaTimer = setTimeout(ctaOff, 6000);
    } else ctaOff();
  }

  function onUserScroll(e) {
    if (!S) return;
    if (Date.now() - S.t0 < 1200) return;         // grace period right after the click
    if (e.target && e.target.closest && e.target.closest('.nfl-xp-bar')) return;
    stop();
  }
  function onKey(e) {
    if (!S) return;
    if (e.key === 'Escape' || e.key === 'Esc') { stop(); return; }
    if (['PageDown', 'PageUp', 'ArrowDown', 'ArrowUp', 'Home', 'End'].indexOf(e.key) > -1 && Date.now() - S.t0 > 1200) stop();
    else if (e.key === ' ' && e.target === document.body) { e.preventDefault(); togglePause(); }
  }
  // pause while the tab is hidden; resume on return only if we paused it
  function onVis() {
    if (!S || S.T0 == null) return;
    if (document.hidden && !S.paused) { togglePause(); S.autoPaused = true; }
    else if (!document.hidden && S.paused && S.autoPaused) { S.autoPaused = false; togglePause(); }
  }

  Array.prototype.forEach.call(triggers, function (b) {
    b.hidden = false;
    b.setAttribute('aria-expanded', 'false');
    b.addEventListener('click', start);
  });

  // floating trigger: show once the hero button is out of view
  var fab = q('.nfl-xp-fab');
  var heroBtn = q('.nfl-hero [data-nfl-explica]');
  if (fab && heroBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) { fab.classList.toggle('is-shown', !en[0].isIntersecting); }).observe(heroBtn);
  } else if (fab) fab.classList.add('is-shown');
})();
